import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { CREATE, FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { DASHBOARD_MODULE } from '../../configs/moduleNames';

export const LOAD_STAT_PARKING_METER = '_LOAD_STAT_PARKING_METER';
export const LOAD_STAT_CAMERA = '_LOAD_STAT_CAMERA';
export const LOAD_LIST_PARKING_METER = '_LOAD_LIST_PARKING_METER';
export const LOAD_LIST_CAMERA = '_LOAD_LIST_CAMERA';

export const loadStatParkingMeter = createDeferredAction(DASHBOARD_MODULE + LOAD_STAT_PARKING_METER);
export const loadStatParkingMeterSuccessful = createAction(DASHBOARD_MODULE + LOAD_STAT_PARKING_METER + SUCCESSFUL);
export const loadStatParkingMeterFailed = createAction(DASHBOARD_MODULE + LOAD_STAT_PARKING_METER + FAILED);

export const loadStatCamera = createDeferredAction(DASHBOARD_MODULE + LOAD_STAT_CAMERA);
export const loadStatCameraSuccessful = createAction(DASHBOARD_MODULE + LOAD_STAT_CAMERA + SUCCESSFUL);
export const loadStatCameraFailed = createAction(DASHBOARD_MODULE + LOAD_STAT_CAMERA + FAILED);

export const loadListParkingMeter = createDeferredAction(DASHBOARD_MODULE + LOAD_LIST_PARKING_METER);
export const loadListParkingMeterSuccessful = createAction(DASHBOARD_MODULE + LOAD_LIST_PARKING_METER + SUCCESSFUL);
export const loadListParkingMeterFailed = createAction(DASHBOARD_MODULE + LOAD_LIST_PARKING_METER + FAILED);

export const loadListCamera = createDeferredAction(DASHBOARD_MODULE + LOAD_LIST_CAMERA);
export const loadListCameraSuccessful = createAction(DASHBOARD_MODULE + LOAD_LIST_CAMERA + SUCCESSFUL);
export const loadListCameraFailed = createAction(DASHBOARD_MODULE + LOAD_LIST_CAMERA + FAILED);
